import { jsx as a } from "react/jsx-runtime";
import t from "../base-button.mjs";
const n = ({ selected: r, ...o }) => /* @__PURE__ */ a(
  t,
  {
    color: r ? "text-brand-primary" : "text-text-primary",
    hoverColor: r ? "hover:text-brand-primary" : "hover:text-text-primary",
    backgroundColor: r ? "bg-brand-primary/10" : "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-brand-primary/10",
    borderColor: r ? "border-brand-primary" : "border-text-secondary/30",
    hoverBorderColor: "border-brand-primary",
    type: "button",
    ...o
  }
);
export {
  n as Chip
};
